var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-template" },
    [
      _vm.role == "student" ? _c("Header") : _c("HeaderTeacher"),
      _c(
        "div",
        { staticClass: "container-box" },
        [
          _vm.isShowMenu ? _c("Menu") : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isFullLoading,
                  expression: "isFullLoading",
                },
              ],
              ref: "ulScroll1",
              staticClass: "content uni-scroll-container",
            },
            [
              _c(
                "div",
                { staticClass: "main-content", attrs: { id: "main-content" } },
                [
                  _c(
                    "keep-alive",
                    { attrs: { include: _vm.keepAliveViews } },
                    [_c("router-view", { on: { scrollTopO: _vm.scrollTopO } })],
                    1
                  ),
                  _vm.isRouterName !== "classRecordData"
                    ? _c("div", { staticClass: "uni-copy-right" }, [
                        _c("i"),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.isUrl(3)
                              },
                            },
                          },
                          [_vm._v("渝公网安备 50010602502220 号")]
                        ),
                        _vm._v("， 技术支持："),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.isUrl(1)
                              },
                            },
                          },
                          [_vm._v("重庆卓培教育科技有限公司")]
                        ),
                        _vm._v("，"),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.isUrl(2)
                              },
                            },
                          },
                          [_vm._v("渝ICP备18010001号-3")]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c("router-view", { attrs: { name: "sideBanner" } }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isDialogFace
        ? _c("DialogFace", { on: { isShowFace: _vm.isShowFace } })
        : _vm._e(),
      false
        ? _c("faceVideo", {
            attrs: { isTest: true, equipment: true },
            on: { isRouter: _vm.isRouterVideo, forcedSubmit: _vm.forcedSubmit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }